<template>
  <Dialog v-model="visible" variant="panel" :title="$t('novShopping.goods.viewDaily')">
    <div class="daily-dialog" :class="isMobile ? 'mobile' : 'pc'">
      <div class="daily-grid">
        <div
          class="daily-item"
          v-for="item in props.list"
          :key="item.goodsCode"
        >
          <div class="daily-date">{{ formatDate(item.activeDate) }}</div>
          <div class="daily-icon">
            <img v-if="!iconErrorMap[item.goodsCode]" :src="getPropIcon(item.propId)" :alt="item.propId" @error="iconErrorMap[item.goodsCode] = true" />
            <span v-else class="icon-fallback">{{ getPropName(t, item).slice(0, 1) }}</span>
          </div>
          <div class="daily-name">{{ getPropName(t, item) }}<span class="daily-count">*{{ item.propCount }}</span></div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, reactive, defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import { isMobile } from '@/utils'
import Dialog from '../Dialog/index.vue'
import { getPropIcon, getPropName } from '../../utils/prop'
import { formatDailyDate } from '../../utils/time'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  list: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['update:modelValue'])

const { t, locale } = useI18n()

const iconErrorMap = reactive({})
const visible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

const formatDate = (activeDate) => formatDailyDate(activeDate, locale.value)

</script>

<style lang="less" scoped>
.daily-dialog {
  .daily-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
    max-height: 52vh;
    overflow-y: auto;
  }

  .daily-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 16px 8px;
    border-radius: 16px;
    background: #f7f4ee;
    cursor: default;

    .daily-date {
      font-size: 22px;
      color: #8c7f6a;
      text-align: center;
      white-space: nowrap;
    }

    .daily-icon {
      width: 84px;
      height: 84px;
      border-radius: 50%;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .icon-fallback {
        font-size: 36px;
        color: #b9a98c;
      }
    }

    .daily-name {
      font-size: 20px;
      text-align: center;
      color: #4a3f2f;
    }
  }
}
</style>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
